import { LinearProgress } from "@mui/material";
import { useIsMutating } from "@tanstack/react-query";
import { siiFundLabelExportMutationKey } from "data/services/api/sii-fund-label/tanstack";
import React from "react";

export const SiiFundLabelExportProgress = () => {
  const pendingExports = useIsMutating({
    mutationKey: siiFundLabelExportMutationKey,
    exact: true,
  });

  return pendingExports > 0 ? (
    <LinearProgress
      aria-label="Exporting SII fund labels"
      data-test-id="sii-export-progress"
    />
  ) : null;
};
